// extracted by mini-css-extract-plugin
export default {"img-resize-handle":"styles_img-resize-handle__o5qs2"};